import { render, staticRenderFns } from "./NewPaymentsHead.vue?vue&type=template&id=29def7f4&scoped=true"
import script from "./NewPaymentsHead.vue?vue&type=script&lang=js"
export * from "./NewPaymentsHead.vue?vue&type=script&lang=js"
import style0 from "./NewPaymentsHead.vue?vue&type=style&index=0&id=29def7f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29def7f4",
  null
  
)

export default component.exports